import Action from "../../classes/Action";
import { StepUIData } from "../../interfaces/UITemplateData";
import store, { StoreActions } from '../../state/store';

export default class DeleteTemplate extends Action
{
	constructor(slide: string)
	{
		const slideCopy: StepUIData = { ...store.getState().uiModule.slideMaster[slide] };

		super(
			[slide],
			[slide, slideCopy],
			`Create Template from step`,
			[slideCopy]
		);
	}

	do(slide: string)
	{
		store.dispatch(StoreActions.ui.deleteSlide({ id: slide }));
	}

	undo(slide: string, slideCopy: StepUIData)
	{
		const slideTemplate = { ...slideCopy };
		delete slideTemplate.synced;
		store.dispatch(StoreActions.ui.setSlideFromCopy({ slide: slide, content: { ...slideTemplate } }));
	}

	verify(slideCopy: StepUIData)
	{
		if (!slideCopy) return false;
		return true;
	}
}
